import { Fragment, useEffect, useState } from "react";
import { Button, Card, Col, Form, GetProp, Modal, Row, Typography, Upload, UploadProps, Image, Input, Select, DatePicker, message } from "antd";
import { useForm } from "antd/es/form/Form";
import { EyeOutlined } from "@ant-design/icons";
import { addArtwork, addArtworkImageResize, addArtworkVersion, convertHeicToJpeg } from "../../../api/artwork";
import { onHandleS3Upload } from "../../s3-bucket/components";
import dayjs from "dayjs";
import './style.scss';
import { Storage } from "aws-amplify";
import { ENVIRONMENT, NEXPYN_BUCKET, REGION } from "../../../common/constants";
// import heic2any from "heic2any";

const ArtWorkModel = (props: any) => {
    const { open, setOpen, artWorkData, page, userId, render, artId } = props;

    const { Text } = Typography;
    const [artWorkForm] = useForm();
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 480);
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);

        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    useEffect(() => {
        if (page === 'view') {
            artWorkForm.setFieldsValue({
                inventoryNo: artWorkData.inventoryNo,
                title: artWorkData.title,
                artistName: artWorkData.artistName,
                height: artWorkData.height,
                width: artWorkData.width,
                depth: artWorkData.depth,
                media: artWorkData.media,
                version: '',
            });
        }
    }, [open]);

    const [profileImage, setProfileImage] = useState<any>();
    const [profileImagePreview, setProfileImagePreview] = useState<string>('');
    const [S3FileUpload, setS3FileUpload] = useState<any[]>([{}]);
    const [submitLoading, setSubmitLoading] = useState<boolean>(false);
    const [convertLoading, setConvertLoading] = useState<boolean>(false);

    type FileType = Parameters<GetProp<UploadProps, 'beforeUpload'>>[0];

    const imageUpload: UploadProps['onChange'] = async (file: any) => {
        try {
            const isjpg = file.type === 'image/png' || 'image/jpeg';
            if (!isjpg) {
                Upload.LIST_IGNORE;
                return false;
            }
            if (!file?.file?.url && !file?.file?.preview) {
                file.file.preview = await getBase64(file?.file?.originFileObj as FileType);
            }
            setProfileImagePreview(file.file.url || (file.file.preview as string));
            if (file?.fileList) {
                setProfileImage(file?.fileList);
            }
            setS3FileUpload([file?.fileList]);
            return true;
        } catch (error) {
            console.error('Error While Upload Image', error);
        }
    };

    const getBase64 = (file: FileType): Promise<string> =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader?.readAsDataURL(file);
            reader.onload = () => resolve(reader.result as string);
            reader.onerror = (error) => reject(error);
        });

    const ArtWorkAdd = () => {

        const fields = [
            "Inventory No",
            "Title",
            "Artist Name",
            "Versions",
            "Date",
            "Examiner",
            // "Media",
            "Width",
            "Height",
            "Depth",
        ];

        const labelName: any = {
            "Inventory No": 'inventoryNo',
            "Title": "title",
            "Artist Name": "artistName",
            "Versions": "version",
            "Date": "date",
            // "Media": "media",
            "Examiner": "examiner",
            "Width": "width",
            "Height": "height",
            "Depth": "depth",
        };

        const inputStyle = {
            // width: isMobile ? '100%' : '438px',
            minHeight: '37px',
            paddingLeft: '12px',
            paddingRight: '12px',
            fontSize: '14px',
            lineHeight: '22px',
            fontWeight: 400,
            background: '#F3F4F6FF',
            borderRadius: '6px',
            borderWidth: '0px',
            outline: 'none'
        };

        const inputLabelStyle = {
            fontSize: '14px',
            lineHeight: '22px',
            fontWeight: 700,
        };

        const options = (value: any) => {
            switch (value) {
                case "Versions":
                    if (page === 'view') {
                        return [{ version: 'Version 1', value: 'Version 1' },
                        { label: 'Version 2', value: 'Version 2' },
                        { label: 'Version 3', value: 'Version 3' },
                        { label: 'Version 4', value: 'Version 4' },
                        { label: 'Version 5', value: 'Version 5' },
                        { label: 'Version 6', value: 'Version 6' },
                        { label: 'Version 7', value: 'Version 7' },
                        { label: 'Version 8', value: 'Version 8' },
                        { label: 'Version 9', value: 'Version 9' },
                        { label: 'Version 10', value: 'Version 10' },
                        { version: 'Version 11', value: 'Version 11' },];
                    } else {
                        return [
                            { label: "Initial version", value: "Initial version" },
                        ];
                    }
                case "Media":
                    return [
                        { label: 'Losses', value: 'Losses' },
                        { label: 'Flaking paint (avoid manipulation)', value: 'Flaking paint (avoid manipulation)' },
                        { label: 'Friable/powdery', value: 'Friable/powdery' },
                        { label: 'Accretions', value: 'Accretions' },
                        { label: 'Smudging', value: 'Smudging' },
                        { label: 'Abrasion', value: 'Abrasion' },
                        { label: 'Discoloration', value: 'Discoloration' },
                        { label: 'Stains', value: 'Stains' },
                        { label: 'Leaching', value: 'Leaching' },
                        { label: 'Fading', value: 'Fading' },
                    ];
                default:
                    return [];
            }
        };
        const selectField = (field: string) => {
            const optionList = options(field);
            return (<>{field === 'Media' ? null : <Select
                options={optionList ? optionList : []}
                mode={!['Versions'].includes(field) ? "multiple" : undefined}
                style={inputStyle}
                disabled={!(page === 'view' && field === 'Versions') && !(page !== 'view' && field === 'Media') || submitLoading}
                getPopupContainer={(triggerNode) => triggerNode?.parentElement ?? document?.body}
            />}
            </>);
        };

        const SubmitForm = async (value: any) => {
            setSubmitLoading(true);
            try {
                const file = S3FileUpload[0]?.[0]?.originFileObj;
                const ArtworkId = artWorkData?.ArtworkMedia?.[0]?.['artworkId'];
                if (page === 'view') {
                    const postData = {
                        artworkId: ArtworkId,
                        userId: userId,
                        fileS3Path: `${ArtworkId}/${value.version}/${file?.name}`,
                        date: dayjs(value.date).format("YYYY-MM-DD"),
                        version: value.version,
                        fileName: file?.name,
                        fileSize: file?.size,
                        fileMimeType: file?.type,
                        originalType: file?.originalType
                    };
                    await addArtworkVersion(postData);
                    if (!file?.originalType) {
                        await onHandleS3Upload(`${ArtworkId}`, value.version, S3FileUpload);
                    }
                    await addArtworkImageResize({
                        fileName: file?.name,
                        version: value.version,
                        fileMimeType: file?.type,
                        artworkId: ArtworkId,
                        type: 'versionUpload'
                    });
                }
                else {
                    const postData = {
                        ...value,
                        date: dayjs(value.date).format("YYYY-MM-DD"),
                        media: ["Accretions"],
                        fileName: file?.name,
                        userId: userId,
                        fileSize: file?.size,
                        fileMimeType: file?.type,
                        originalType: file?.originalType

                    };
                    const { data } = await addArtwork(postData);
                    if (data?.identifiers?.[0]?.id) {
                        if (!file?.originalType) {
                            await onHandleS3Upload(`${data.identifiers[0].id}`, value.version || "Initial version", S3FileUpload);
                        }
                        await addArtworkImageResize({
                            fileName: file?.name,
                            version: value.version,
                            fileMimeType: file?.type,
                            artworkId: data.identifiers[0].id,
                            type: 'initialUpload'
                        });
                    }
                }
                setOpen(false);
                artWorkForm.resetFields();
                setProfileImage([]);
            } catch (err) {
                console.error("Video Submit Error:", err);
            } finally {
                const param = page === "view" ? { artId: artId } : { filter: [] };
                setSubmitLoading(false);
                render({
                    ...param,
                    userId: userId
                });
            }
        };

        return (
            <Fragment>
                <Card className='upload-artwork-component' styles={{ body: { padding: isMobile ? 8 : 10 } }}>
                    <Form
                        layout="vertical"
                        form={artWorkForm}
                        onFinish={SubmitForm}
                        requiredMark={false}
                    >
                        <div className="scroll-section">
                            <Form.Item
                                name={'profileImage'}
                                required={true}
                                rules={[
                                    {
                                        required: true,
                                        message: "Please upload profile",
                                    },
                                ]}>
                                <Row style={{ gap: isMobile ? 8 : 10 }}>
                                    <Col>
                                        <Col>
                                            <p
                                                style={{
                                                    fontSize: isMobile ? '12px' : '14px',
                                                    lineHeight: '22px',
                                                    fontWeight: 700,
                                                    color: '#323743FF',
                                                    marginLeft: isMobile ? 5 : 10

                                                }}>
                                                Artwork Image
                                            </p>
                                        </Col>
                                        <Col
                                            style={{
                                                borderRadius: 10,
                                                background: '#9095a0',
                                                textAlign: 'center',
                                                height: isMobile ? 80 : 100,
                                                display: 'flex',
                                                justifyContent: "center",
                                                alignItems: 'center',
                                                margin: isMobile ? 5 : 10,
                                                width: isMobile ? 80 : 100
                                            }}>
                                            {profileImage?.length && profileImagePreview ?
                                                <Image
                                                    preview={{ mask: <EyeOutlined /> }}
                                                    src={profileImagePreview}
                                                    height={isMobile ? 80 : 100}
                                                    style={{ objectFit: 'cover' }}
                                                /> :
                                                <svg xmlns="http://www.w3.org/2000/svg" width={isMobile ? 40 : 50} height={isMobile ? 40 : 50} viewBox="0 0 24 24"><path fill="#9095a0" d="M20.37 21.25a.75.75 0 0 1-.75.75H4.38a.75.75 0 0 1-.75-.75c0-4.1 4.5-7.28 8.37-7.28s8.37 3.18 8.37 7.28M17.1 7.11A5.1 5.1 0 1 1 12 2a5.11 5.11 0 0 1 5.1 5.11" stroke="#fff" />
                                                </svg>
                                            }
                                        </Col>
                                    </Col>

                                    <Col style={{ marginTop: isMobile ? 0 : 20 }}>
                                        <Text
                                            style={{
                                                fontSize: isMobile ? '12px' : '14px',
                                                lineHeight: ' 22px',
                                                fontWeight: 400,
                                                color: '#171A1FFF'
                                            }}>
                                            Upload your artwork image
                                        </Text>
                                        <Col style={{ marginTop: 6 }}>
                                            <Text
                                                style={{
                                                    fontSize: isMobile ? '10px' : '12px',
                                                    lineHeight: '20px',
                                                    fontWeight: 400,
                                                    color: '#565D6DFF',
                                                }}>
                                                Supported file formats - PNG, JPG, JPEG, HEIC, HEIF, HEVC
                                            </Text>
                                        </Col>
                                        <Row align={"middle"} style={{ marginTop: 5, gap: isMobile ? 5 : 10 }}>
                                            <Upload
                                                disabled={submitLoading}
                                                accept=".png,.jpg,.jpeg,.heic,.heif,.hevc"
                                                showUploadList={false}
                                                maxCount={1}
                                                beforeUpload={async (file: any) => {
                                                    const ext = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
                                                    const heicTypes = ['.heic', '.heif', '.hevc'];

                                                    if (heicTypes.includes(ext)) {
                                                        setConvertLoading(true);
                                                        const hide = message.loading("HEIC file format not supported directly — converting to JPEG file format. This may take a few seconds...", 0);
                                                        try {
                                                            Storage.configure({
                                                                bucket: NEXPYN_BUCKET,
                                                                region: REGION,
                                                                customPrefix: {
                                                                    public: `HEICToJPEG/`
                                                                }
                                                            });
                                                            await Storage.put(file.name, file, {
                                                                contentType: file.type,
                                                            });

                                                            const { success, key } = await convertHeicToJpeg({ key: file.name });
                                                            const previewUrl = `https://${ENVIRONMENT}-image.s3.us-east-1.amazonaws.com/${encodeURIComponent(key)}`;
                                                            setProfileImagePreview(previewUrl);
                                                            setProfileImage([{
                                                                uid: file.uid,
                                                                name: key,
                                                                url: previewUrl,
                                                                status: 'done',
                                                                originFileObj: file,
                                                            }]);
                                                            setS3FileUpload([[{
                                                                originFileObj: {
                                                                    name: key.split('/').pop(),
                                                                    size: file.size,
                                                                    type: "image/jpeg",
                                                                    originalType: 'heic'
                                                                }
                                                            }]]);
                                                            hide();

                                                            if (success) {
                                                                message.success("HEIC uploaded and converted successfully!");
                                                            } else {
                                                                message.error("Conversion failed");
                                                            }
                                                            return Upload.LIST_IGNORE;
                                                        } catch (error) {
                                                            hide();
                                                            message.error("Upload or conversion failed");
                                                            console.error(error);
                                                        } finally {
                                                            setConvertLoading(false);
                                                        }
                                                    }
                                                }}
                                                onChange={imageUpload}
                                            >
                                                <Button
                                                    disabled={submitLoading || convertLoading}
                                                    style={{
                                                        fontSize: isMobile ? '10px' : '12px',
                                                        fontWeight: 400,
                                                        color: '#636AE8FF',
                                                        background: '#FFFFFFFF',
                                                        opacity: 1,
                                                        borderRadius: '4px',
                                                        borderWidth: '1px',
                                                        borderColor: '#636AE8FF',
                                                        borderStyle: 'solid',
                                                        padding: isMobile ? '4px 8px' : '6px 12px'
                                                    }}>
                                                    Choose image
                                                </Button>
                                            </Upload>
                                            {profileImage?.length && profileImagePreview ?
                                                <Button
                                                    disabled={submitLoading || convertLoading}
                                                    onClick={() => {
                                                        artWorkForm.resetFields(['profileImage']);
                                                        setProfileImage([]);
                                                        setProfileImagePreview('');
                                                    }}
                                                    style={{
                                                        fontSize: isMobile ? "10px" : "12px",
                                                        borderColor: '#DE3B40',
                                                        opacity: 1,
                                                        borderRadius: '4px',
                                                        borderWidth: '1px',
                                                        color: ' #DE3B40',
                                                        borderStyle: 'solid',
                                                        padding: isMobile ? '4px 8px' : '6px 12px'
                                                    }} >
                                                    Remove image
                                                </Button> : ''}
                                        </Row>
                                    </Col>

                                </Row>
                            </Form.Item>
                            {fields?.reduce((acc, field, index) => {
                                if (index % 2 === 0) {
                                    acc.push([field]);
                                } else {
                                    acc[acc.length - 1].push(field);
                                }
                                return acc;
                            }, [] as string[][]).map((rowFields, rowIndex) => (
                                <Row gutter={[isMobile ? 12 : 8, 16]} key={rowIndex}>
                                    {rowFields.map((field) => (
                                        <Col span={isMobile ? 24 : 12} key={field}>
                                            <Form.Item
                                                label={
                                                    <span style={inputLabelStyle}>
                                                        {field === "Media"
                                                            ? null
                                                            : field === "Date"
                                                                ? "Date of Artwork"
                                                                : field}
                                                        <span style={{ fontSize: 12, marginLeft: 4 }}>
                                                            {["Width", "Height", "Depth"].includes(field)
                                                                ? "(in inches)"
                                                                : null}
                                                        </span>
                                                    </span>
                                                }
                                                name={labelName[field]}
                                                initialValue={field === "Versions" ? "Initial version" : undefined}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: ["Versions", "Media"].includes(field)
                                                            ? `Please select ${field.toLowerCase()}`
                                                            : field === "Date"
                                                                ? "Please pick a date"
                                                                : `Please enter ${field.toLowerCase()}`,
                                                    },
                                                ]}
                                            >
                                                {["Versions", "Media"].includes(field) ? (
                                                    selectField(field)
                                                ) : field === "Date" ? (
                                                    <DatePicker
                                                        disabled={submitLoading}
                                                        style={{ ...inputStyle, width: "100%" }}
                                                    />
                                                ) : (
                                                    <Input
                                                        disabled={
                                                            (page === "view" &&
                                                                ["Inventory No", "Title", "Artist Name", "Width", "Height", "Depth"].includes(field)) ||
                                                            submitLoading
                                                        }
                                                        style={{ ...inputStyle }}
                                                    />
                                                )}
                                            </Form.Item>
                                        </Col>
                                    ))}

                                    {rowFields.includes("Date") && (
                                        <Col span={24}>
                                            <h3
                                                style={{
                                                    marginTop: 2,
                                                    marginBottom: 10,
                                                    marginLeft: isMobile ? 5 : 10,
                                                    fontSize: isMobile ? "16px" : "18px",
                                                }}
                                            >
                                                Measurements
                                            </h3>
                                        </Col>
                                    )}
                                </Row>

                            ))}
                        </div>
                        <Row justify={"end"} gutter={isMobile ? 8 : 16} style={{ marginTop: 10 }}>
                            <Col>
                                <Button
                                    key="back"
                                    danger
                                    disabled={submitLoading || convertLoading}
                                    onClick={() => { setOpen(false); artWorkForm.resetFields(); setProfileImage([]); }}
                                    style={{
                                        fontSize: isMobile ? '12px' : '14px',
                                        fontWeight: 400,
                                        borderRadius: '6px',
                                        padding: isMobile ? '4px 12px' : '6px 16px'
                                    }}
                                >
                                    Cancel
                                </Button>
                            </Col>
                            <Col>
                                <Button
                                    htmlType="submit"
                                    loading={submitLoading}
                                    disabled={submitLoading || convertLoading}
                                    style={{
                                        fontSize: isMobile ? '12px' : '14px',
                                        lineHeight: '22px',
                                        fontWeight: 400,
                                        color: '#FFFFFFFF',
                                        background: '#636AE8FF',
                                        opacity: 1,
                                        border: 'none',
                                        borderRadius: '6px',
                                        padding: isMobile ? '4px 12px' : '6px 16px'
                                    }}
                                >
                                    Upload
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </Card>
            </Fragment >
        );
    };

    return (
        <Modal
            title={
                <span
                    style={{
                        fontSize: isMobile ? '18px' : '24px',
                        lineHeight: isMobile ? '24px' : '36px',
                        fontWeight: 700,
                        color: '#171A1FFF'
                    }}>
                    Upload Artwork
                </span >
            }
            open={open}
            centered
            maskClosable={false}
            onCancel={() => {
                if (submitLoading || convertLoading) {
                    message.warning("Please wait, your previous request is still processing.");
                    return;
                }
                setOpen(false);
                artWorkForm.resetFields();
                setProfileImage([]);
            }}
            width={isMobile ? '95%' : 1000}
            footer={null}
            className="upload-artwork-modal"
        >
            {ArtWorkAdd()}
        </Modal>
    );
};
export default ArtWorkModel;